'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _configuration = require('../configuration');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common validator for single target effects
// Effects using this validator should be wrapped into an object with the shape:
// {
//   realTarget: the target being modified. Notice that it may be different of action.target,
//   do: the effect itself
// }
function validateEffect(effect) {
  return function (state, action) {
    if (!action.target) {
      console.warn('There is no target specified for ' + effect.name + '.');
    }
    if (state[effect.realTarget(action)] === undefined) {
      // TODO: RESTORE THIS WARNING
      // console.warn(`Missing field declaration for ${effect.realTarget(action)}.`);
    }
    return (0, _configuration.mergeState)(state, (0, _defineProperty3.default)({}, effect.realTarget(action), effect.do(action, state)));
  };
}

exports.default = validateEffect;